__webpack_require__.p = "https://www.ikea.com/bh/en/local-apps/alsulaiman-purchase-handler/";